// extracted by mini-css-extract-plugin
export default {"backdrop":"_2mkChHOy","root":"_2Y3Nuf6C","header":"_1qTlQw_X","content":"jq-TTVyt","title":"O6Jy7geQ","list":"_38EmaREO"};